import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "company" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_content = _resolveComponent("page-content")!
  const _component_page_modal = _resolveComponent("page-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_content, {
      contentTableConfig: _ctx.contentTableConfig,
      pageName: "company",
      btnName: "新建发货公司",
      onSeeBtnClick: _ctx.handleSeeData,
      onNewBtnClick: _ctx.handleNewData,
      onEditBtnClick: _ctx.handleEditData
    }, null, 8, ["contentTableConfig", "onSeeBtnClick", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_page_modal, {
      ref: "pageModalRef",
      modalConfig: _ctx.modalConfig,
      defaultInfo: _ctx.defaultInfo,
      rules: _ctx.rules,
      pageName: "company",
      dialogWidth: "30%"
    }, null, 8, ["modalConfig", "defaultInfo", "rules"])
  ]))
}